import { isDocumentsReturnUrlPath } from '@/routes/documents-editor-paths'
import { paths } from '@/paths'

export const RETURN_URL_QUERY_PARAM = 'returnUrl'

export function getCurrentReturnPath(
  pathname: string,
  search: string,
  hash: string
): string {
  return `${pathname}${search}${hash}`
}

function getPathnameFromReturnPath(returnPath: string): string {
  try {
    const url = new URL(returnPath, 'http://localhost')
    return url.pathname
  } catch {
    return returnPath.split('?')[0]?.split('#')[0] ?? returnPath
  }
}

function isSafeRelativePath(returnPath: string): boolean {
  if (!returnPath.startsWith('/')) {
    return false
  }
  if (returnPath.startsWith('//')) {
    return false
  }
  if (returnPath.includes('://') || returnPath.includes('\\')) {
    return false
  }
  const lower = returnPath.toLowerCase()
  if (lower.startsWith('/auth/') || lower === '/auth') {
    return false
  }
  return true
}

export function getSafeDocumentsReturnUrl(
  raw: string | null | undefined,
  fallback: string = paths.dashboard.index
): string {
  if (!raw) {
    return fallback
  }

  let decoded = raw
  try {
    decoded = decodeURIComponent(raw)
  } catch {
    return fallback
  }

  if (!isSafeRelativePath(decoded)) {
    return fallback
  }

  const pathname = getPathnameFromReturnPath(decoded)
  if (!isDocumentsReturnUrlPath(pathname)) {
    return fallback
  }

  return decoded
}

export function buildLoginUrlWithReturn(returnPath: string): string {
  const params = new URLSearchParams()
  params.set(RETURN_URL_QUERY_PARAM, returnPath)
  return `${paths.auth.jwt.login}?${params.toString()}`
}

export function getReturnUrlFromSearch(search: string): string | null {
  const params = new URLSearchParams(search)
  return params.get(RETURN_URL_QUERY_PARAM)
}
